import SectionPay from './SectionPay';
export default SectionPay;
